import { TableCell, TableRow, Tooltip } from '@mui/material'
import React from 'react'
// import { unitMeasureShortText } from '../../../../../helpers/unitMeasure/UnitMeasureHelper'
import { getLinksByText } from '../../../../../helpers/link/LinkHelper'
import MyCheckBox from '../../../../UI/form/MyCheckBox'
import MyTableCheckBox from '../../../../UI/table/MyTableCheckBox'
import SupplyOrderItemAgree from '../items/fields/SupplyOrderItemAgree'
import ReceivedItemIco from '../items/actions/changeReceived/ReceivedItemIco'
import SupplyOrderItemLinks from '../items/link/SupplyOrderItemLinks'
import UnitMeasureShortText from '../../../../unitMeasure/UnitMeasureShortText'

const SupplyOrderItemShort = ({ supplyOrderItem, index, checked, setChecked }) => {
  return (
    <TableRow>
        {/* <MyTableCheckBox 
            id={supplyOrderItem.id}
            checked={checked}
            setChecked={setChecked}
        /> */}
        <TableCell align='center'>
            <Tooltip title={`ID ${supplyOrderItem.id}`}>
                {
                    index + 1
                }
            </Tooltip>
        </TableCell>
        <TableCell align='center' className='wordBreakAll'>
            {
				supplyOrderItem.name
			}
        </TableCell>
        <TableCell align='center'>
            <div className='supplyCounts'>
                <p className='supplyCounts__green'>
                    <Tooltip title='Вже є в рахунках'>
                        {supplyOrderItem.countInBill ? supplyOrderItem.countInBill : 0}
                    </Tooltip>
                </p>
                <span>/</span>
                <p className='supplyCounts__yellow'>
                    <Tooltip title='Ще треба замовити'>
                        {supplyOrderItem.countFree}
                    </Tooltip>
                </p>
                <span>/</span>
                <p>
                    <Tooltip title='Всього'>
                        {supplyOrderItem.count}
                    </Tooltip>
                </p>
                {/* <p>
                    {
                        unitMeasureShortText[supplyOrderItem.unitMeasure]
                    }
                </p> */}
                <UnitMeasureShortText unitMeasure={supplyOrderItem.unitMeasure} />
            </div>
        </TableCell>
         <TableCell align='center'>
            <SupplyOrderItemLinks
                links={supplyOrderItem.links}
            />
        </TableCell>
        <TableCell align='center'>
            <SupplyOrderItemAgree
                supplyOrderItem={supplyOrderItem}
            />
        </TableCell>
        <TableCell align='center'>
            <ReceivedItemIco
                supplyOrderItem={supplyOrderItem}
            />
        </TableCell>
    </TableRow>
  )
}

export default SupplyOrderItemShort